import React, { useEffect, useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function ErrorBoundary({ children }) {
    const [hasError, setHasError] = useState(false);
    const [error, setError] = useState(null);
    const { t } = useTranslation();

    useEffect(() => {
        const normalize = (err, fallbackMsg) => {
            if (err instanceof Error) return err;
            const msg = (typeof err === 'string' ? err : err?.message) || fallbackMsg || 'Unknown error';
            const e = new Error(msg);
            e.__original = err;
            return e;
        };

        const onError = (e) => {
            const msg = e?.message || e?.error?.message || '';
            const noisy = msg === 'Script error.' ||
                /ResizeObserver loop (limit exceeded|completed with undelivered notifications)/i.test(msg);
            const isGeneric = (msg === 'Script error.' || msg === 'Script error') && !e?.filename;
            if (noisy || isGeneric) {
                console.warn('[ignored error]', msg, e);
                return;
            }
            setHasError(true);
            setError(normalize(e?.error ?? e, msg));
        };

        const onRejection = (e) => {
            const reason = e?.reason;
            const msg = (typeof reason === 'string' ? reason : reason?.message) || '';
            const isGeneric = msg === 'Script error.' || msg === 'Script error';
            if (isGeneric) {
                console.warn('[ignored generic promise rejection]', e);
                return;
            }
            setHasError(true);
            setError(normalize(reason ?? e, msg));
        };

        window.addEventListener('error', onError);
        window.addEventListener('unhandledrejection', onRejection);
        return () => {
            window.removeEventListener('error', onError);
            window.removeEventListener('unhandledrejection', onRejection);
        };
    }, []);

    if (hasError) {
        return (
            <Box sx={{ p: 2, textAlign: 'center' }}>
                <Typography variant="h5">{t('errorOccurred') || 'Xatolik yuz berdi'}</Typography>
                <Typography sx={{ mt: 1, wordBreak: 'break-word' }}>
                    {error?.message || t('unknownError') || 'Noma’lum xato'}
                </Typography>
                <Button sx={{ mt: 2 }} variant="contained" onClick={() => window.location.reload()}>
                    {t('refreshPage') || 'Sahifani yangilash'}
                </Button>
            </Box>
        );
    }
    return children;
}
